import { useCallback } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { ChatThread } from "./ChatThread";

export const SupportView = () => {
  const load = useCallback(() => api.get("/support/messages").then((r) => r.data), []);
  const sendFn = useCallback((text) => api.post("/support/messages", { text }).then((r) => r.data), []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-6 h-full flex flex-col" data-testid="support-view">
      <p className="hud-tag mb-2">Canale diretto</p>
      <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-1">Chat con il Super Admin</h2>
      <p className="text-sm text-slate-400 mb-4 flex items-center gap-2"><ShieldCheck size={15} className="text-emerald-300" /> Conversazione privata 1-a-1 con il team Aurora ON.</p>
      <div className="hud-card flex-1 min-h-[420px] flex flex-col overflow-hidden">
        <ChatThread load={load} sendFn={sendFn} mine="user" emptyText="Scrivi il tuo primo messaggio: ti risponderemo al più presto." />
      </div>
    </div>
  );
};
